<template>
  <div>
    <div
      :class="{
        'nav-btn d-none d-lg-flex flex-column align-items-center justify-content-center mx-2 user-drop-toggle': true,
        selected: isOpen || currentSelectedPage === 'me',
      }"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <img
        :src="currentSelectedPage === 'me' ? getUserImgFilled() : getUserImg()"
        alt="user image"
      />
      <div class="pt-2">
        <span>Me</span>
      </div>
    </div>

    <div class="btn-group mr-2 d-none d-lg-block">
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" to="/me"> My Profile </router-link>
        <div class="dropdown-divider"></div>
        <router-link class="dropdown-item" to="/scenarios/upload">
          Upload Scenarios
        </router-link>
        <router-link class="dropdown-item" to="/media/upload">
          Upload Media
        </router-link>
        <div class="dropdown-divider"></div>
        <router-link class="dropdown-item" to="/me/scenarios">
          My Scenarios
        </router-link>
        <router-link class="dropdown-item" to="/me/media">My Media</router-link>
        <router-link class="dropdown-item" to="/me/forum/groups">
          My Groups
        </router-link>
        <div v-if="isAdmin" class="dropdown-divider"></div>
        <router-link v-if="isAdmin" class="dropdown-item" to="/admin">
          Admin Dashboard
        </router-link>
        <div class="dropdown-divider"></div>
        <router-link class="dropdown-item" to="/logout">Sign out</router-link>
      </div>
    </div>
    <!-- ^ desktop ^ -->

    <div class="btn-group mr-2 d-block d-lg-none">
      <div id="accordion">
        <div class="card mt-2">
          <button
            class="card-header btn btn-primary d-flex py-3 rounded"
            data-toggle="collapse"
            data-target="#loggedInUser"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <i class="material-icons" style="margin-right: 7px">person</i>
            <span>{{ user }}</span>
          </button>

          <div
            id="loggedInUser"
            class="collapse"
            aria-labelledby="userProfile"
            data-parent="#loggedInUser"
          >
            <div class="card-body">
              <div class>
                <router-link class="dropdown-item" to="/scenarios/upload">
                  Upload Scenarios
                </router-link>
                <router-link class="dropdown-item" to="/media/upload">
                  Upload Media
                </router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/me/scenarios">
                  My Scenarios
                </router-link>
                <router-link class="dropdown-item" to="/me/media">
                  My Media
                </router-link>
                <router-link class="dropdown-item" to="/me/forum/groups">
                  My Groups
                </router-link>
                <div v-if="isAdmin" class="dropdown-divider"></div>
                <router-link v-if="isAdmin" class="dropdown-item" to="/admin">
                  Admin Dashboard
                </router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/logout">
                  Sign out
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
  </div>
</template>

<script>
import { Role } from "@/utils/user.helper";

export default {
  name: "LoggedInUser",
  data: function () {
    return {
      isOpen: false,
    };
  },
  mounted() {
    $(".user-drop-toggle")
      .parent()
      .on("hidden.bs.dropdown", () => {
        this.isOpen = false;
      })
      .on("shown.bs.dropdown", () => {
        this.isOpen = true;
      });
  },
  computed: {
    isAdmin() {
      return (this.$store.getters.getUserRole & Role.Admin) !== 0;
    },
  },
  props: {
    user: String,
    currentSelectedPage: String,
  },
  methods: {
    getUserImg() {
      return require("../../assets/nav-icons/user.svg");
    },
    getUserImgFilled() {
      return require("../../assets/nav-icons/user-fill.svg");
    },
  },
};
</script>

<style scoped>
@media (max-width: 991px) {
  .btn-group {
    width: 100%;
  }
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -1px;
}
</style>
